import React from 'react';
import CategoryRow from '../CategoryRow';

const Electronic = () => (
  <CategoryRow title="Electronics" category="Electronics" exploreTo="/all-electronic-item" />
);

export default Electronic;
